import * as React from 'react';

import {SelectReact} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';
import {Placement, TooltipAttrs} from 'common/components/tooltip/types';
import {Segmentation} from 'common/types/reports/query';
import {SCDOptionsType} from 'common/widgets/property-filter-menu/models/types';
import {SegmentValue} from 'common/query-builder/query-block/segment-menu/types';
import {ButtonSize} from 'common/components/button/constants';
import {ChangeEvent} from 'common/components/select/types';

import timelineLatestSvg from './timeline-latest.svg';
import timelineAllSvg from './timeline-all.svg';

type LabelFn = {t: (key: string) => string};

export function getSCDOptionsTypeSections(scdOptions?: Segmentation['scdOptions']) {
  const items = [
    {
      label: ({t}: LabelFn) => t(`filters.scd-options-type.latest`),
      value: SCDOptionsType.Latest,
      tooltip: {
        text: ({t}: LabelFn) => t(`filters.scd-options-type.tooltip.latest`),
        'image-src': timelineLatestSvg,
        'max-width': `140px`,
      } as TooltipAttrs,
      isSelected: scdOptions?.type === SCDOptionsType.Latest || !scdOptions?.type, // latest is the default
    },
    {
      label: ({t}: LabelFn) => t(`filters.scd-options-type.any`),
      value: SCDOptionsType.Any,
      tooltip: {
        text: ({t}: LabelFn) => t(`filters.scd-options-type.tooltip.any`),
        'image-src': timelineAllSvg,
        'max-width': `140px`,
      } as TooltipAttrs,
      isSelected: scdOptions?.type === SCDOptionsType.Any,
    },
  ];
  return [{items}];
}

export function SegmentSCDOptionsSelector(props: {
  hasNewUI: boolean;
  readonly?: boolean;
  segment: Segmentation;
  onSelect?: (value: SegmentValue) => void;
}) {
  return (
    <div className='mp-query-sub-selector'>
      <SelectReact
        className='subitem-select'
        elref='segmentScdOptionsSelector'
        menuWidth={200}
        alwaysShowCaret={props.hasNewUI}
        theme={SelectTheme.QbSubitem}
        size={ButtonSize.Small}
        tooltip={{placement: Placement.Top}}
        readonly={props.readonly}
        sections={getSCDOptionsTypeSections(props.segment.scdOptions)}
        onChange={
          (({detail}: ChangeEvent<SCDOptionsType | undefined>) => {
            props.onSelect?.({
              ...props.segment,
              scdOptions: {
                ...props.segment?.scdOptions,
                type: detail.item.value,
              },
            });
          }) as any
        }
      />
    </div>
  );
}
